<template>
  <div>
    <vx-card title="Информация о пропуске" class="mb-8">
      <div class="vx-row">
        <div class="vx-col flex-1">
          <table>
            <tr>
              <td class="font-semibold">ФИО на кого заявка</td>
              <td class="pl-4">
                <span class="text-primary">{{ pass.full_name }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Адрес</td>
              <td class="pl-4">
                <p>
                  <span class="text-primary">{{
                    pass.home.county_type.name
                  }}</span
                  >, участок #
                  <span class="text-primary">{{
                    pass.home.homestead_number
                  }}</span
                  >, ул.
                  <span class="text-primary">{{ pass.home.address }}</span>
                </p>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Цена</td>
              <td class="pl-4">
                <span class="text-primary">{{ pass.price }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Оплачен</td>
              <td class="pl-4">
                <span class="text-primary">{{
                  pass.is_paid ? "Да" : "Нет"
                }}</span>
              </td>
            </tr>

            <tr v-if="pass.description">
              <td class="font-semibold">Примечание</td>
              <td class="pl-4">
                <span class="text-primary">{{ pass.description }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">На гостя</td>
              <td class="pl-4">
                <span class="text-primary">{{
                  pass.is_guest ? "Да" : "Нет"
                }}</span>
              </td>
            </tr>

            <tr v-if="pass.photo">
              <td class="font-semibold">Фото паспорта</td>
              <td class="pl-4">
                <a
                  class="text-primary"
                  icon-pack="feather"
                  icon="icon-paperclip"
                  target="_blank"
                  :href="baseURL + pass.photo"
                >
                  <feather-icon
                    icon="PaperclipIcon"
                    class="inline-block align-middle"
                    svgClasses="w-4 h-4"
                  />
                  Фото паспорта
                </a>
              </td>
            </tr>
            <tr v-if="pass.passport_scan">
              <td class="font-semibold">Скан паспорта</td>
              <td class="pl-4">
                <a
                  class="text-primary"
                  icon-pack="feather"
                  icon="icon-paperclip"
                  target="_blank"
                  :href="baseURL + pass.passport_scan"
                >
                  <feather-icon
                    icon="PaperclipIcon"
                    class="inline-block align-middle"
                    svgClasses="w-4 h-4"
                  />
                  Скан паспорта
                </a>
              </td>
            </tr>
          </table>
        </div>

        <div class="vx-col flex-1">
          <table>
            <tr>
              <td class="font-semibold">Тип пропуска</td>
              <td class="pl-4">
                <span class="text-primary">{{ pass.kind.name }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Даты пропуска</td>
              <td
                class="pl-4"
                v-if="pass.date_booked_to && pass.date_booked_from"
              >
                Пропуск действует с
                <span class="text-primary">{{ pass.date_booked_from }}</span> до
                <span class="text-primary">{{ pass.date_booked_to }}</span>
              </td>
              <td class="pl-4" v-else>
                Пропуск действует
                <span class="text-primary">{{ pass.date_booked }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Тип авто</td>
              <td class="pl-4">
                <span class="text-primary">{{ pass.car_type.name }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Марка авто</td>
              <td class="pl-4">
                <span class="text-primary">{{ pass.car }}</span>
              </td>
            </tr>
            <tr>
              <td class="font-semibold">Номер авто</td>
              <td class="pl-4">
                <span class="text-primary font-bold">{{
                  pass.car_number
                }}</span>
              </td>
            </tr>
            <tr v-if="pass.passenger_number">
              <td class="font-semibold">Количество пассажиров</td>
              <td class="pl-4">
                <span class="text-primary font-bold">{{
                  pass.passenger_number
                }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </vx-card>

    <vx-card title="Отметки проезда" class="mb-8">
      <vs-table
        :data="actionsPass"
        :stripe="true"
        :search="true"
        :pagination="false"
        :maxItems="20"
        noDataText="Элементов не найдено"
      >
        <template slot="thead">
          <vs-th> Тип проезда </vs-th>
          <vs-th> Дата </vs-th>
          <vs-th> Цена </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              {{ data[indextr].kind == "entry" ? "Въезд" : "Выезд" }}
            </vs-td>

            <vs-td :data="formatDateTime(data[indextr].date)">
              {{ formatDateTime(data[indextr].date) }}
            </vs-td>

            <vs-td> {{ pass.price }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>
      <div class="price-sum pt-3 flex justify-end">
        <h4>
          Сумма:
          <span class="text-bold">{{ actionsPass.length * pass.price }}</span>
        </h4>
      </div>
    </vx-card>

    <vx-card
      v-if="!pass.passport_scan"
      title="Загрузить скан паспорта"
      class="mb-8"
    >
      <picture-input
        ref="pictureInputScan"
        @change="onChangeScan"
        name="Скан паспорта"
        width="200"
        height="200"
        margin="1"
        accept="image/jpeg,image/png"
        size="15"
        buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
        :customStrings="{
          upload: '<h1>Загрузить изображение</h1>',
          drag: 'Загрузите изображение',
          change: 'Изменить изображение',
          remove: 'Удалить изображение',
          select: 'Выбрать изображение',
        }"
      >
      </picture-input>
    </vx-card>

    <vx-card v-if="!pass.photo" title="Загрузить фото паспорта" class="mb-8">
      <picture-input
        ref="pictureInputPhoto"
        @change="onChangePhoto"
        name="Фото паспорта"
        width="200"
        height="200"
        margin="1"
        accept="image/jpeg,image/png"
        size="15"
        buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
        :prefill="pass.photo"
        :customStrings="{
          upload: '<h1>Загрузить изображение</h1>',
          drag: 'Загрузите изображение',
          change: 'Изменить изображение',
          remove: 'Удалить изображение',
          select: 'Выбрать изображение',
        }"
      >
      </picture-input>
    </vx-card>
  </div>
</template>

<script>
import { API_URL, passType, carType, countyType } from "@/.env";
import PictureInput from "vue-picture-input";

import { DateTime } from "luxon";

export default {
  data: () => ({
    baseURL: API_URL,
    actionsPass: [],

    pass: [],
    carType,
    passType,
    countyType,
    sumPrice: 0,
  }),
  components: {
    PictureInput,
    DateTime,
  },
  watch: {
    "$route.params.id": {
      handler: function (id) {
        this.getTicket(id);
      },
    },
  },
  computed: {},
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDateTime(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    getInfoPass(id) {
      this.$load(async () => {
        let res = (await this.$api.passes.getActionsPass(id)).data;

        this.actionsPass = res.marks;

        let pass = res.passs;

        pass.kind = this.passType.find((x) => x.id == pass.kind);
        pass.car_type = this.carType.find((x) => x.id == pass.car_type);
        pass.home.county_type = this.countyType.find(
          (x) => x.id == pass.home.county_type
        );

        if (pass.date_booked) {
          pass.date_booked = DateTime.fromFormat(
            pass.date_booked,
            "yyyy-MM-dd"
          ).toFormat("dd.MM.yyyy");
        }

        if (pass.date_booked_to) {
          pass.date_booked_to = DateTime.fromFormat(
            pass.date_booked_to,
            "yyyy-MM-dd"
          ).toFormat("dd.MM.yyyy");
        }

        if (pass.date_booked_from) {
          pass.date_booked_from = DateTime.fromFormat(
            pass.date_booked_from,
            "yyyy-MM-dd"
          ).toFormat("dd.MM.yyyy");
        }

        this.pass = res.passs;
      });
    },
    onChangePhoto() {
      let payload = {
        photo: this.$refs.pictureInputPhoto.file,
      };

      this.uploadImage("photo", payload);
    },
    onChangeScan() {
      let payload = {
        passport_scan: this.$refs.pictureInputScan.file,
      };

      this.uploadImage("scan", payload);
    },
    uploadImage(type, data) {
      this.$load(async () => {
        let res;
        if (type == "photo") {
          res = await this.$api.passes.uploadPhotoPass(
            this.$route.params.id,
            data
          );
        } else if (type == "scan") {
          res = await this.$api.passes.uploadScanPass(
            this.$route.params.id,
            data
          );
        }

        if (res.status == 200) {
          this.notification(
            "Успешно",
            "Изображение успешно обновлено",
            "success"
          );
        } else {
          this.notification(
            "Ошибка",
            "Не удалось обновить изображение",
            "danger"
          );
        }
      });
    },
  },
  created() {},
  mounted() {
    this.getInfoPass(this.$route.params.id);
  },
};
</script>